export const isClientSide = typeof window !== 'undefined';
